var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ops-dashboard-base"},[_c('div',{staticClass:"ops-header"},[_c('h1',{staticClass:"ops-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"ops-controls"},[_vm._t("controls")],2)]),_c('div',{staticClass:"ops-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }